import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { LogOut, Package, ShoppingCart, FileText, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api, formatPrice } from "../lib/api";
import { AdminProducts } from "../components/admin/AdminProducts";
import { AdminOrders } from "../components/admin/AdminOrders";
import { AdminQuotes } from "../components/admin/AdminQuotes";

const TABS = [
  { k: "produits", label: "Produits", icon: Package },
  { k: "commandes", label: "Commandes", icon: ShoppingCart },
  { k: "devis", label: "Demandes de devis", icon: FileText },
];

export default function Admin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("produits");
  const [stats, setStats] = useState(null);

  const loadStats = () => api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { if (user) loadStats(); }, [user]);

  if (user === null) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-8 w-8 animate-spin text-royal" /></div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <main data-testid="admin-page" className="min-h-screen bg-ice pt-28 pb-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="eyebrow text-royal">Administration</p>
            <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">Tableau de bord</h1>
            <p className="mt-2 text-sm text-slate-500">{user.email}</p>
          </div>
          <button data-testid="admin-logout-button" onClick={async () => { await logout(); navigate("/"); }} className="btn-outline"><LogOut className="h-4 w-4" /> Déconnexion</button>
        </div>

        {stats && (
          <div data-testid="admin-stats" className="mt-10 grid grid-cols-2 gap-px bg-navy/10 md:grid-cols-4">
            {[["Produits", stats.products], ["Commandes", stats.orders], ["Devis", stats.quotes], ["Chiffre payé", formatPrice(stats.revenue)]].map(([l, v]) => (
              <div key={l} className="bg-white p-6"><p className="eyebrow text-royal">{l}</p><p className="mt-2 font-display text-2xl font-bold text-navy">{v}</p></div>
            ))}
          </div>
        )}

        <div className="mt-10 flex gap-2 border-b border-navy/10">
          {TABS.map((t) => (
            <button key={t.k} data-testid={`admin-tab-${t.k}`} onClick={() => setTab(t.k)} className={`-mb-px flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors ${tab === t.k ? "border-royal text-royal" : "border-transparent text-slate-500 hover:text-navy"}`}>
              <t.icon className="h-4 w-4" /> {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8">
          {tab === "produits" && <AdminProducts onChange={loadStats} />}
          {tab === "commandes" && <AdminOrders onChange={loadStats} />}
          {tab === "devis" && <AdminQuotes />}
        </div>
      </div>
    </main>
  );
}
